import React from 'react'
import { motion } from 'framer-motion'

const ShimmerEffect = ({ width, height, className = '' }) => {
  return (
    <div
      style={{
        width,
        height,
        borderRadius: '4px',
        overflow: 'hidden',
      }}
      className={`bg-gray-200 ${className}`}
    >
      <motion.div
        style={{
          width: '100%',
          height: '100%',
          background: 'linear-gradient(90deg, transparent 0%, #f0f0f0 50%, transparent 100%)',
        }}
        animate={{
          x: ['-100%', '100%'],
        }}
        transition={{
          repeat: Infinity,
          duration: 1.5,
          ease: 'linear',
        }}
      />
    </div>
  )
}

export default ShimmerEffect